import { styled } from '@mui/material/styles'

const PREFIX = 'FooterStyles'
export const classes = {
  root: `${PREFIX}-root`
}

export const FooterStyles = styled('div')(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: 'relative',
    zIndex: 4,
    padding: 30,
    backgroundColor: theme.mode === 'dark' ? '#4c4c4c' : '#e8e8e8',
    '& p': {
      color: theme.mode === 'dark' ? '#bebaba' : '#000'
    }
  }
}))
